module.exports = __webpack_public_path__ + "static/media/ronholt_marker.82ea29d8.svg";